export const PAGINATION_DOTS = "dots" as const;

type PaginationItem = number | typeof PAGINATION_DOTS;

interface PaginationOptions {
  totalPages: number;
  currentPage: number;
  maxLength?: number;
}

const createRange = (start: number, end: number): number[] => {
  const range: number[] = [];
  for (let i = start; i <= end; i += 1) {
    range.push(i);
  }
  return range;
};

export const getPaginationItems = ({
  totalPages,
  currentPage,
  maxLength = 7,
}: PaginationOptions): PaginationItem[] => {
  if (totalPages <= 0) {
    return [];
  }

  const clampedCurrent = Math.max(1, Math.min(currentPage, totalPages));
  const adjustedMaxLength = Math.max(5, Math.floor(maxLength));

  if (totalPages <= adjustedMaxLength) {
    return createRange(1, totalPages);
  }

  const siblings = Math.max(1, Math.floor((adjustedMaxLength - 3) / 2));
  const leftSibling = Math.max(clampedCurrent - siblings, 2);
  const rightSibling = Math.min(clampedCurrent + siblings, totalPages - 1);

  const showLeftDots = leftSibling > 2;
  const showRightDots = rightSibling < totalPages - 1;

  const pages: PaginationItem[] = [1];

  if (showLeftDots) {
    pages.push(PAGINATION_DOTS);
  } else {
    pages.push(...createRange(2, leftSibling - 1));
  }

  pages.push(...createRange(leftSibling, rightSibling));

  if (showRightDots) {
    pages.push(PAGINATION_DOTS);
  } else {
    pages.push(...createRange(rightSibling + 1, totalPages - 1));
  }

  pages.push(totalPages);

  return pages;
};

export type { PaginationItem };

